/* Preserve the visible purchase choice during this product's Kaching variant switch. */
(function(){
  function install(){
    var previous=window.getSellingPlanId;
    if(previous && previous.__travelSetCheckedPlan) return;
    var selectedPlan=function(){
      var checkbox=document.querySelector('input[name="subscription_enabled"][data-selling-plan-id]');
      if(checkbox) return checkbox.checked ? (checkbox.dataset.sellingPlanId || null) : null;
      return typeof previous==='function' ? previous.apply(this,arguments) : null;
    };
    selectedPlan.__travelSetCheckedPlan=true;
    window.getSellingPlanId=selectedPlan;
  }
  window.addEventListener('click',function(event){
    var target=event.target;
    var button=target && target.closest && target.closest('button[type="submit"],button[name="add"],.product-form__submit');
    if(button && button.closest('form[action*="/cart/add"]')) install();
  },true);
  window.addEventListener('submit',install,true);
  install();
})();
